import React from 'react';
import { cn } from '../../lib/utils';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          'inline-flex items-center justify-center rounded-full font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide',
          {
            'bg-nolimit-red text-white hover:bg-red-600 focus:ring-nolimit-red': variant === 'primary',
            'bg-white text-black hover:bg-gray-200 focus:ring-white': variant === 'secondary',
            'border-2 border-white text-white hover:bg-white hover:text-black': variant === 'outline',
            'hover:bg-white/10 text-white': variant === 'ghost',
            'h-9 px-4 text-xs': size === 'sm',
            'h-12 px-6 text-sm': size === 'md',
            'h-14 px-8 text-base': size === 'lg',
          },
          className
        )}
        {...props}
      />
    );
  }
);
Button.displayName = 'Button';
